import React, { useContext, useEffect, useState } from 'react'
import { ref, listAll, getDownloadURL } from "firebase/storage";
import { storage } from '../firebase.js'

import Card from '../component/ui/Card.js';
import d21 from './SubjectSummaries.module.css'
import Loader from '../component/ui/Visual-utilities/Loader.js';
import UserContext from '../store/UserContext.js';


function SubjectsSummaries() {
  let userCtx = useContext(UserContext);
  let userData = userCtx.user;

  const [isLoading, setIsLaoding] = useState(true)

  const [itemList, setItemList] = useState([]);

  const [overlay, setOverlay] = useState(false);
  const [iframeSrc, setIframeSrc] = useState();

  useEffect(() => {

    const getFiles = async () => { // Create a reference under which you want to list
      const listRef = ref(storage, '/subject summary/' + userData.grade);
      await listAll(listRef)
        .then((res) => {

          res.items.forEach((itemRef) => {

            // All the items under listRef.
            getDownloadURL(itemRef).then((url) => {
              setIsLaoding(false);
              console.log('source: ' + itemRef.name + " " + url)
              setItemList(itemList => [...itemList, { name: itemRef.name, url: url, id: itemRef }]);

            }).catch(() => console.log('no files '))
          });
        }).catch(() => console.log('no files '))

    }



    getFiles();

  }, [userData])
  function toggleOverlay(src) {
    setIframeSrc(src);
    setOverlay(!overlay);
  }

  return (
    <div>
      subject summaries
      {isLoading && <Loader />}
      {itemList.length === 0 && "No files available at the moment"}

      {overlay && <div className={d21.SummaryOverlay}>
        <div className={d21.overlayMenu} onClick={() => toggleOverlay()}>
          <h4>Back</h4></div>
        <div className={d21.loadingText}>  </div>
        <iframe title={iframeSrc}
          src={iframeSrc}


        />
      </div>}
      {itemList.map((n, index) => {
        return <Card key={index} >

          <div className={d21.item} onClick={() => toggleOverlay(n.url)}>
            {n.name}
          </div>

        </Card>
      })}
    </div>
  )
}

export default SubjectsSummaries
